import type { IconProps } from './Icon.types';

const ErrorIcon: React.FC<IconProps> = ({
  fill = 'var(--color-error, #ED0E0E)',
  height = 16,
  width = 16,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.33325 9.99992V11.3333H8.66659V9.99992H7.33325ZM7.33325 4.66659V8.66659H8.66659V4.66659H7.33325Z"
      fill={fill}
    />
  </svg>
);

export default ErrorIcon;
